// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PersistentError = (() => {
    function PersistentErrorConstructor(message, cause) {
        if (Object.prototype.hasOwnProperty.call(Error, 'captureStackTrace')) {
            Error.captureStackTrace(this, this.constructor);
        }
        else {
            this.stack = (new Error()).stack;
        }
        this.message = (message || 'An unexpected persistent error occurred.');
        this.name = this.constructor.name;
        if (cause) {
            this.cause = cause;
            if (cause.stack) {
                this.stack += `\nCaused By: ${cause.stack}`;
            }
        }
    }
    // custom errors must be manually extended, since JS Errors can't be super called in a class hierarchy,
    // otherwise the super call destroys the origin 'this' reference
    PersistentErrorConstructor.prototype = Object.create(Error.prototype, {
        constructor: {
            value: PersistentErrorConstructor,
            writable: true,
            enumerable: false,
            configurable: true,
        },
    });
    return PersistentErrorConstructor;
})();
PersistentError.of = function of(error) {
    if (error instanceof PersistentError) {
        return error;
    }
    return new PersistentError(null, error);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGVyc2lzdGVudEVycm9yLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiUGVyc2lzdGVudEVycm9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQW9DQSwyREFBMkQ7QUFDM0QsTUFBTSxDQUFDLE1BQU0sZUFBZSxHQUFHLENBQUMsR0FBRyxFQUFFO0lBQ25DLFNBQVMsMEJBQTBCLENBQXdCLE9BQXNCLEVBQUUsS0FBYTtRQUM5RixJQUFJLE1BQU0sQ0FBQyxTQUFTLENBQUMsY0FBYyxDQUFDLElBQUksQ0FBQyxLQUFLLEVBQUUsbUJBQW1CLENBQUMsRUFBRTtZQUNwRSxLQUFLLENBQUMsaUJBQWlCLENBQUMsSUFBSSxFQUFFLElBQUksQ0FBQyxXQUFXLENBQUMsQ0FBQztTQUNqRDthQUFNO1lBQ0wsSUFBSSxDQUFDLEtBQUssR0FBRyxDQUFDLElBQUksS0FBSyxFQUFFLENBQUMsQ0FBQyxLQUFLLENBQUM7U0FDbEM7UUFFRCxJQUFJLENBQUMsT0FBTyxHQUFHLENBQUMsT0FBTyxJQUFJLDBDQUEwQyxDQUFDLENBQUM7UUFDdkUsSUFBSSxDQUFDLElBQUksR0FBRyxJQUFJLENBQUMsV0FBVyxDQUFDLElBQUksQ0FBQztRQUVsQyxJQUFJLEtBQUssRUFBRTtZQUNULElBQUksQ0FBQyxLQUFLLEdBQUcsS0FBSyxDQUFDO1lBQ25CLElBQUksS0FBSyxDQUFDLEtBQUssRUFBRTtnQkFDZixJQUFJLENBQUMsS0FBSyxJQUFJLGdCQUFnQixLQUFLLENBQUMsS0FBSyxFQUFFLENBQUM7YUFDN0M7U0FDRjtJQUNILENBQUM7SUFFRCx1R0FBdUc7SUFDdkcsZ0VBQWdFO0lBQ2hFLDBCQUEwQixDQUFDLFNBQVMsR0FBRyxNQUFNLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxTQUFTLEVBQUU7UUFDcEUsV0FBVyxFQUFFO1lBQ1gsS0FBSyxFQUFFLDBCQUEwQjtZQUNqQyxRQUFRLEVBQUUsSUFBSTtZQUNkLFVBQVUsRUFBRSxLQUFLO1lBQ2pCLFlBQVksRUFBRSxJQUFJO1NBQ25CO0tBQ0YsQ0FBQyxDQUFDO0lBRUgsT0FBTywwQkFBK0QsQ0FBQztBQUN6RSxDQUFDLENBQUMsRUFBRSxDQUFDO0FBRUwsZUFBZSxDQUFDLEVBQUUsR0FBRyxTQUFTLEVBQUUsQ0FBQyxLQUFZO0lBQzNDLElBQUksS0FBSyxZQUFZLGVBQWUsRUFBRTtRQUNwQyxPQUFPLEtBQUssQ0FBQztLQUNkO0lBRUQsT0FBTyxJQUFJLGVBQWUsQ0FBQyxJQUFJLEVBQUUsS0FBSyxDQUFDLENBQUM7QUFDMUMsQ0FBQyxDQUFDIn0=